import React from 'react'
import { PlaybookProgressIcon } from '../../components/PlaybookProgressIcon'

export const progressColumn = {
  label: '',
  accessor: 'progress',
  format: (value) => {
    return <PlaybookProgressIcon progress={value} />
  },
}

export const organizationColumn = {
  label: 'Organization',
  accessor: 'organizationName',
  format: (value) => (
    <div style={{ maxWidth: '250px', whiteSpace: 'initial' }}>
      <span>{value}</span>
    </div>
  ),
}
